"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignBy = void 0;
const gatherBy_1 = require("./gatherBy");
function assignBy(array, pathOrFn) {
    return (0, gatherBy_1.gatherBy)(array, pathOrFn, (result, key, element) => {
        result[key] = element;
    });
}
exports.assignBy = assignBy;
//# sourceMappingURL=assignBy.js.map